import { useMemo } from 'react';

import isEqual from 'lodash/isEqual';

import { usePrevious } from '@cast/utils';

import { useChartConfig } from '../../ChartConfigProvider';

type IsAnimationActive = boolean | 'auto' | undefined;

type Props = {
  value: unknown;
  isAnimationActive?: IsAnimationActive;
};

export const useIsAnimationActive = ({
  value,
  isAnimationActive: isAnimationActiveProp,
}: Props) => {
  const { isAnimationActive } = useChartConfig({
    isAnimationActive: isAnimationActiveProp,
  });

  const previousValue = usePrevious(value);

  return useMemo(() => {
    if (previousValue && !isEqual(previousValue, value)) {
      return isAnimationActive;
    }
    return false;
  }, [isAnimationActive, previousValue, value]);
};
